import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

function CategoryArticlePage() {
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(0);
    const [limit] = useState(10);

    const [form, setForm] = useState({
        id: null,
        name: '',
    });

    const [showModal, setShowModal] = useState(false);
    const [editing, setEditing] = useState(false);

    const fetchData = async () => {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/admin/datatable/category-article`, {
        params: { start: page * limit, length: limit, search },
        withCredentials: true,
        });
        setData(res.data.data);
        setTotal(res.data.recordsFiltered);
    };

    useEffect(() => {
        fetchData();
    }, [page, search]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.name) {
            Swal.fire('Oops!', 'Semua field harus diisi.', 'error');
            return;
        }

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/category-article`, form, { withCredentials: true });
            setShowModal(false);
            fetchData();
            resetForm();
            Swal.fire('Berhasil', 'Data berhasil disimpan', 'success');
        } catch (error) {
            Swal.fire('Oops!', (err.response?.data?.message || "Silakan coba lagi."), 'error');
        }
    };

    const resetForm = () => {
        setForm({
            id: null,
            name: '',
        });
        setEditing(false);
    };

    const openCreateModal = () => {
        resetForm();
        setShowModal(true);
    };

    const editForm = async (item) => {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/admin/category-article/${item.id}`, { withCredentials: true });
        setForm(res.data);
        setEditing(true);
        setShowModal(true);
    };

    const deleteItem = async (id) => {

        const result = await Swal.fire({
            title: 'Yakin ingin menghapus data ini',
            text: 'Data akan dihapus secara permanen.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ya, hapus!',
            cancelButtonText: 'Batal'
        });
    
        if (result.isConfirmed) {
            try {
                await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/admin/category-article/${id}`, { withCredentials: true });
                Swal.fire('Berhasil', 'Data berhasil dihapus.', 'success');
                fetchData();
            } catch (err) {
                Swal.fire('Oops!', (err.response?.data?.message || "Silakan coba lagi."), 'error');
            }
        }

    };

  return (
    <div className="container-fluid px-0">
        <h3>Manage Kategori Artikel</h3>

        <div className='mb-2 row'>
        <div className='col'>
            <input type="text" className="form-control" placeholder="Cari Data..." value={search} onChange={(e) => setSearch(e.target.value)} />
        </div>
        <div className='col-auto'>
            <button className="btn btn-dark form-control" onClick={openCreateModal}><i className='fa fa-plus'></i> Tambah Data Baru</button>
        </div>
        </div>

        <div className='table-responsive'>
        <table className="table table-hover table-striped table-bordered table-sm">
            <thead>
            <tr>
                <th className='bg-light'>Nama</th>
                <th className='text-center bg-light' width="10%">Aksi</th>
            </tr>
            </thead>
            <tbody>
            {data.map((item) => (
                <tr key={item.id}>
                <td>{item.name}</td>
                <td className="text-center">
                    <button className="btn btn-sm btn-outline-dark me-1" onClick={() => editForm(item)}><i className="fa fa-edit"></i></button>
                    <button className="btn btn-sm btn-outline-dark" onClick={() => deleteItem(item.id)}><i className="fa fa-trash"></i></button>
                </td>
                </tr>
            ))}
            </tbody>
        </table>
        </div>

        <div className="d-flex justify-content-between">
        <small>Total: {total}</small>
        <div>
            <button className="btn btn-sm btn-secondary me-2" disabled={page === 0} onClick={() => setPage(page - 1)}>Prev</button>
            <button className="btn btn-sm btn-secondary" disabled={(page + 1) * limit >= total} onClick={() => setPage(page + 1)}>Next</button>
        </div>
        </div>

        {showModal && (
        <div className="modal d-block" tabIndex="-1">
            <div className="modal-dialog modal-lg">
            <div className="modal-content">
                <form onSubmit={handleSubmit}>
                <div className="modal-header">
                    <h5 className="modal-title">{editing ? 'Edit' : 'Tambah'} Kategori Artikel</h5>
                    <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>
                <div className="modal-body row g-2">
                    <div className="col-md-12">
                        <label>Nama</label>
                        <input type="text" className="form-control" name="name" value={form.name} onChange={handleChange} required />
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="submit" className="btn btn-dark">{editing ? 'Update' : 'Simpan'}</button>
                    <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Tutup</button>
                </div>
                </form>
            </div>
            </div>
        </div>
        )}
    </div>
    );
}

export default CategoryArticlePage;
